import type {ReactElement} from 'react';
import React from 'react';
import {ContextualMenuSliderOptions} from '@Components/contextual-menu/components/contextual-menu-slider-options';
import {MAX_GRADIENT_EDGE_THICKNESS, MIN_GRADIENT_EDGE_THICKNESS} from '@PosterWhiteboard/classes/item-effects.class';

interface BaseGradientEdgeEffectThicknessOptionProps {
  edgeThickness: number;
  onUpdateThickness(value: number, undoable?: boolean): void;
}

export function BaseGradientEdgeEffectThicknessOption({...props}: BaseGradientEdgeEffectThicknessOptionProps): ReactElement<any> | null {
  const onChangeEdgeThickness = (edgeThickness: number): void => {
    props.onUpdateThickness(edgeThickness, false);
  };

  const onChangeEdgeThicknessEnded = (edgeThickness: number): void => {
    props.onUpdateThickness(edgeThickness, true);
  };

  return (
    <ContextualMenuSliderOptions
      id="item-gradient-opacity-amount"
      value={props.edgeThickness}
      label={window.i18next.t('pmwjs_opacity')}
      range={{
        min: MIN_GRADIENT_EDGE_THICKNESS,
        max: MAX_GRADIENT_EDGE_THICKNESS,
      }}
      delayForOnChange={350}
      addDelayToOnChange
      onChange={onChangeEdgeThickness}
      onChangeEnded={onChangeEdgeThicknessEnded}
    />
  );
}
